import { useAccountStore } from '@/stores/account-store'

const read = () => useAccountStore.getState().session?.tokens.accessToken ?? null

/**
 * Token provider for `@edge/edge-ai` (chat POST, transcribe/speak WebSockets,
 * TTS), which cannot read the app store itself. Refreshes via the store action
 * when the access token is missing instead of sending an empty Bearer (which
 * 401s instantly — 2026-08-24 incident); never a bare authService.refreshSession().
 */
export async function companionAuthToken(): Promise<string> {
  const token = read()
  if (token) return token
  await useAccountStore
    .getState()
    .refreshSession()
    .catch(() => {})
  return read() ?? ''
}
